import { render, staticRenderFns } from "./card-wrapper.vue?vue&type=template&id=36c47696"
import script from "./card-wrapper.vue?vue&type=script&lang=ts"
export * from "./card-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports